import { api } from './base';

import { MutationArg, Pageable } from 'v2/types';
import { ReferralRaffle, ReferralRaffleRequest } from 'v2/types/ReferralRaffleModel';
import { SWRKeyPaginationWithExtra, SWRKeyValue } from 'v2/types/swr';
import { exportFile } from 'v2/utils';

interface RaffleFilter {
  name: string;
}

export const referralRaffleService = {
  getRaffles([_key, page, limit, filter]: SWRKeyPaginationWithExtra<RaffleFilter>): Promise<Pageable<ReferralRaffle>> {
    return api
      .get('v1/admin/referral-raffle', {
        searchParams: { page, limit, filter: JSON.stringify(filter) },
      })
      .json();
  },

  createRaffle(_key: string, { arg }: MutationArg<ReferralRaffleRequest>): Promise<ReferralRaffle> {
    return api.post('v1/admin/referral-raffle', { json: arg }).json();
  },

  updateRaffle([_key, raffleId]: SWRKeyValue, { arg }: MutationArg<ReferralRaffleRequest>): Promise<ReferralRaffle> {
    return api.put(`v1/admin/referral-raffle/${raffleId}`, { json: arg }).json();
  },

  deleteRaffle([_key, raffleId]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/referral-raffle/${raffleId}`).json();
  },

  exportRaffleParticipants([_key, raffleId]: SWRKeyValue): Promise<void> {
    return api
      .get(`v1/admin/referral-raffle/${raffleId}/export`)
      .blob()
      .then((blob) => exportFile(blob, 'raffle_participants.xlsx'));
  },

  toggleRaffleActive([_key, raffleId]: SWRKeyValue): Promise<ReferralRaffle> {
    return api.patch(`v1/admin/referral-raffle/${raffleId}/active`).json();
  },
};
